import { Component } from 'utils/jsx'
import { writable } from 'utils/state'
import classnames from 'classnames'
import help from 'controllers/help'

export default class Step extends Component {
  beforeRender (props) {
    this.handleVisibility = this.handleVisibility.bind(this)

    this.state = {
      hidden: writable(props.hidden)
    }
  }

  validate () {
    const firstInvalid = this.base.querySelector('.is-invalid [contentEditable]')
    if (firstInvalid) firstInvalid.focus()

    const isValid = this.props.validate
      ? !firstInvalid && this.props.validate()
      : !firstInvalid

    if (!isValid) help()
    return isValid
  }

  template (props) {
    return (
      <section
        class={classnames('step', props.class)}
        store-hidden={this.state.hidden}
        data-name={props.name}
      >
        <div class='step__content'>
          {props.children}
        </div>
      </section>
    )
  }

  afterRender () {
    this.state.hidden.subscribe(this.handleVisibility)
  }

  handleVisibility () {
    if (this.state.hidden.get()) return

    const firstFocusable = this.base.querySelector('[input], [contentEditable]')
    if (firstFocusable) window.setTimeout(() => firstFocusable.focus(), 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Step.js